<template>
  <div class="ebe-root">

    <!-- Barra de variáveis -->
    <div class="ebe-vars">
      <span class="ebe-vars__label">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M8 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3"/><path d="M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3"/></svg>
        Variáveis
      </span>
      <div class="ebe-vars__chips">
        <button
          v-for="v in VARIAVEIS"
          :key="v.token"
          type="button"
          class="ebe-chip"
          :title="v.descricao"
          @click="insertVariable(v.token)"
        >
          <span class="ebe-chip__brace" v-text="lb"></span>{{ v.key }}<span class="ebe-chip__brace" v-text="rb"></span>
        </button>
      </div>
    </div>

    <!-- Abas + meta -->
    <div class="ebe-tabs">
      <div class="ebe-tabs__nav">
        <button
          type="button"
          class="ebe-tab"
          :class="{ 'ebe-tab--active': activeTab === 'editor' }"
          @click="activeTab = 'editor'"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          Editar
        </button>
        <button
          type="button"
          class="ebe-tab"
          :class="{ 'ebe-tab--active': activeTab === 'preview' }"
          @click="activeTab = 'preview'"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          Prévia
        </button>
        <button
          type="button"
          class="ebe-tab"
          :class="{ 'ebe-tab--active': activeTab === 'plaintext' }"
          @click="activeTab = 'plaintext'"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
          Texto Plano
        </button>
      </div>
      <span v-if="charCount > 0" class="ebe-char-count">{{ charCount }} chars</span>
    </div>

    <!-- Editor -->
    <div v-show="activeTab === 'editor'" class="ebe-panel">
      <vue-editor
        ref="quillEditor"
        v-model="htmlContent"
        :editor-toolbar="customToolbar"
        @text-change="onTextChange"
      />
    </div>

    <!-- Prévia -->
    <div v-show="activeTab === 'preview'" class="ebe-panel ebe-panel--preview">
      <div v-if="isEmpty" class="ebe-preview-empty">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
        <span>Sem conteúdo para exibir</span>
      </div>
      <div v-else class="ebe-email-card">
        <div class="ebe-email-card__meta">
          <div class="ebe-email-card__row">
            <span class="ebe-email-card__key">De</span>
            <span class="ebe-email-card__val">noreply@versotech.com.br</span>
          </div>
          <div class="ebe-email-card__row">
            <span class="ebe-email-card__key">Para</span>
            <span class="ebe-email-card__val">contato@distribuidora.com.br</span>
          </div>
          <div class="ebe-email-card__row">
            <span class="ebe-email-card__key">Assunto</span>
            <span class="ebe-email-card__val ebe-email-card__val--assunto" :class="{ 'ebe-email-card__val--placeholder': !previewAssunto }">
              {{ previewAssunto || '(sem assunto configurado)' }}
            </span>
          </div>
        </div>
        <div class="ebe-email-card__greeting">Olá, <strong>Distribuidora Exemplo Ltda</strong></div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="ebe-email-card__body ql-editor" v-html="previewHtml"></div>
        <div class="ebe-email-card__link-b2b" :class="{ 'ebe-email-card__link-b2b--hidden': !previewLinkB2b }">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
          Acesse: <span class="ebe-email-card__link-url">https://app.versotech.com.br/area-do-cliente/sac/ticket/1042</span>
        </div>
        <div class="ebe-email-card__footer" :class="{ 'ebe-email-card__footer--hidden': !previewMensagemAutomatica }">
          Mensagem automática · não responda este e-mail
        </div>
      </div>
    </div>

    <!-- Texto plano -->
    <div v-show="activeTab === 'plaintext'" class="ebe-panel ebe-panel--plaintext">
      <div class="ebe-plaintext-info">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        Gerado automaticamente para clientes de e-mail sem suporte a HTML
      </div>
      <textarea class="ebe-plaintext-area" readonly :value="plainText" rows="8" spellcheck="false" />
    </div>

  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

const VARIAVEIS = [
  { key: 'numero_ticket',       token: '{{numero_ticket}}',       descricao: 'ID do ticket' },
  { key: 'assunto_ticket',      token: '{{assunto_ticket}}',      descricao: 'Assunto do ticket' },
  { key: 'status_ticket',       token: '{{status_ticket}}',       descricao: 'Status atual' },
  { key: 'etapa_atual',         token: '{{etapa_atual}}',         descricao: 'Etapa atual' },
  { key: 'setor_atual',         token: '{{setor_atual}}',         descricao: 'Setor responsável' },
  { key: 'nome_cliente',        token: '{{nome_cliente}}',        descricao: 'Nome do cliente' },
  { key: 'email_cliente',       token: '{{email_cliente}}',       descricao: 'E-mail do cliente' },
  { key: 'nome_representante',  token: '{{nome_representante}}',  descricao: 'Nome do representante' },
  { key: 'email_representante', token: '{{email_representante}}', descricao: 'E-mail do representante' },
]

const CUSTOM_TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean'],
]

const PREVIEW_EXAMPLES = {
  '{{numero_ticket}}':       '#1042',
  '{{assunto_ticket}}':      'Devolução de produto',
  '{{status_ticket}}':       'ABERTO',
  '{{etapa_atual}}':         'Análise',
  '{{setor_atual}}':         'Suporte Técnico',
  '{{nome_cliente}}':        'Distribuidora Exemplo Ltda',
  '{{email_cliente}}':       'contato@distribuidora.com.br',
  '{{nome_representante}}':  'Carlos Silva',
  '{{email_representante}}': 'carlos.silva@empresa.com',
}

export default {
  name: 'EmailBodyEditor',
  components: { VueEditor },
  props: {
    value: { type: String, default: '' },
    /** Objeto/array de valores dos parâmetros keyed por índice: { "1": ":ticket", "2": "Titulo", ... } */
    allParams: { type: [Object, Array], default: () => ({}) },
    /** Metadata dos parâmetros keyed por índice: { "1": { name, class, ... }, "2": { name, ... }, ... } */
    paramsMeta: { type: [Object, Array], default: () => ({}) },
  },
  data() {
    return {
      activeTab: 'editor',
      htmlContent: this.value || '',
      VARIAVEIS,
      customToolbar: CUSTOM_TOOLBAR,
      lb: '{{',
      rb: '}}',
      // Mapa reativo derivado via watch: { titulo: "...", exibirMensagemAutomatica: true, ... }
      resolvedParams: {},
    }
  },
  computed: {
    isEmpty() {
      return !this.htmlContent || this.htmlContent === '<p><br></p>'
    },
    previewHtml() {
      if (this.isEmpty) return ''
      let html = this.htmlContent
      Object.entries(PREVIEW_EXAMPLES).forEach(([token, val]) => {
        const escaped = token.replace(/[{}]/g, '\\$&')
        html = html.replace(new RegExp(escaped, 'g'), `<mark class="ebe-var-mark">${val}</mark>`)
      })
      return html
    },
    plainText() {
      if (this.isEmpty) return ''
      const el = document.createElement('div')
      el.innerHTML = this.htmlContent
      el.querySelectorAll('br').forEach((n) => n.replaceWith('\n'))
      el.querySelectorAll('p, div, h1, h2, h3').forEach((n) => n.insertAdjacentText('beforeend', '\n'))
      el.querySelectorAll('li').forEach((n) => n.insertAdjacentText('afterbegin', '• '))
      return (el.textContent || el.innerText || '').replace(/\n{3,}/g, '\n\n').trim()
    },
    previewAssunto() {
      return this.resolvedParams.titulo || this.resolvedParams.assunto || null
    },
    previewMensagemAutomatica() {
      const val = this.resolvedParams.exibirMensagemAutomatica
      return val !== 0 && val !== false && val !== 'false' && val !== '0'
    },
    previewLinkB2b() {
      const val = this.resolvedParams.incluiLinkB2b
      return val !== 0 && val !== false && val !== 'false' && val !== '0'
    },
    charCount() {
      if (this.isEmpty) return 0
      const el = document.createElement('div')
      el.innerHTML = this.htmlContent
      return (el.textContent || '').length
    },
  },
  watch: {
    value(val) {
      if (val !== this.htmlContent) this.htmlContent = val || ''
    },
    htmlContent(val) {
      this.$emit('input', val)
    },
    allParams: {
      deep: true,
      immediate: true,
      handler() { this.buildResolvedParams() },
    },
    paramsMeta: {
      deep: true,
      immediate: true,
      handler() { this.buildResolvedParams() },
    },
  },
  methods: {
    buildResolvedParams() {
      const meta = this.paramsMeta
      const vals = this.allParams
      if (!meta || !vals) { this.resolvedParams = {}; return }
      const result = {}
      Object.entries(meta).forEach(([key, paramMeta]) => {
        if (paramMeta && paramMeta.name) {
          result[paramMeta.name] = vals[key]
        }
      })
      this.resolvedParams = result
    },
    onTextChange() {
      this.$emit('input', this.htmlContent)
    },
    insertVariable(token) {
      const quill = this.$refs.quillEditor && this.$refs.quillEditor.quill
      if (quill) {
        this.activeTab = 'editor'
        this.$nextTick(() => {
          quill.focus()
          const range = quill.getSelection(true)
          const index = range ? range.index : quill.getLength() - 1
          quill.insertText(index, token, 'user')
          quill.setSelection(index + token.length)
        })
      } else {
        this.htmlContent = (this.htmlContent || '') + token
      }
    },
  },
}
</script>

<style scoped>
/* Root */
.ebe-root {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

/* ── Variáveis ──────────────────────────────────────── */
.ebe-vars {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 12px;
  background: #f8faff;
  border-bottom: 1px solid #e5e7eb;
}

.ebe-vars__label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding-top: 2px;
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  white-space: nowrap;
  flex-shrink: 0;
}

.ebe-vars__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.ebe-chip {
  display: inline-block;
  padding: 2px 8px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Consolas', 'Menlo', 'Courier New', monospace;
  font-size: 11px;
  color: #1d4ed8;
  line-height: 1.6;
  transition: background 0.12s, border-color 0.12s, transform 0.1s;
  white-space: nowrap;
}

.ebe-chip:hover {
  background: #dbeafe;
  border-color: #93c5fd;
  transform: translateY(-1px);
}

.ebe-chip:active {
  transform: translateY(0);
}

.ebe-chip__brace {
  opacity: 0.45;
  font-size: 10px;
}

/* ── Abas ───────────────────────────────────────────── */
.ebe-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 0 0;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.ebe-tabs__nav {
  display: flex;
}

.ebe-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 14px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
  margin-bottom: -1px;
  white-space: nowrap;
}

.ebe-tab svg {
  flex-shrink: 0;
}

.ebe-tab:hover {
  color: #374151;
}

.ebe-tab--active {
  color: #1d4ed8;
  border-bottom-color: #1d4ed8;
  font-weight: 600;
}

.ebe-char-count {
  font-size: 11px;
  color: #9ca3af;
  padding: 0 10px;
  font-variant-numeric: tabular-nums;
}

/* ── Painel base ────────────────────────────────────── */
.ebe-panel {
  min-height: 190px;
  background: #fff;
}

/* ── Quill overrides ────────────────────────────────── */
.ebe-panel ::v-deep .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 6px 10px;
}

.ebe-panel ::v-deep .ql-container.ql-snow {
  border: none;
}

.ebe-panel ::v-deep .ql-editor {
  min-height: 148px;
  padding: 12px 14px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13.5px;
  color: #1f2937;
  line-height: 1.65;
}

.ebe-panel ::v-deep .ql-editor.ql-blank::before {
  color: #d1d5db;
  font-style: normal;
  font-size: 13px;
}

.ebe-panel ::v-deep .ql-editor p {
  margin-bottom: 0.5em;
}

/* ── Prévia ─────────────────────────────────────────── */
.ebe-panel--preview {
  background: #f3f4f6;
  padding: 16px;
}

.ebe-preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 120px;
  color: #9ca3af;
  font-size: 12px;
}

.ebe-email-card {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  max-width: 520px;
  margin: 0 auto;
  box-shadow: 0 1px 6px rgba(0,0,0,.06);
}

.ebe-email-card__meta {
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ebe-email-card__row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
}

.ebe-email-card__key {
  min-width: 54px;
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  flex-shrink: 0;
}

.ebe-email-card__val {
  color: #6b7280;
}

.ebe-email-card__greeting {
  padding: 12px 16px 4px;
  font-size: 13.5px;
  color: #374151;
  border-bottom: 1px solid #f9fafb;
}

.ebe-email-card__greeting strong {
  color: #111827;
}

.ebe-email-card__body {
  padding: 12px 16px 8px;
  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 13.5px;
  color: #374151;
  line-height: 1.6;
  border: none;
  min-height: 40px;
}

.ebe-email-card__val--assunto {
  font-weight: 600;
  color: #111827;
}

.ebe-email-card__val--placeholder {
  font-weight: 400;
  color: #d1d5db;
  font-style: italic;
}

.ebe-email-card__link-b2b {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  background: #eff6ff;
  border-top: 1px solid #dbeafe;
  font-size: 11.5px;
  color: #1d4ed8;
}

.ebe-email-card__link-url {
  text-decoration: underline;
  opacity: 0.7;
  font-size: 11px;
}

.ebe-email-card__link-b2b--hidden {
  opacity: 0.3;
  text-decoration: line-through;
  filter: grayscale(1);
}

.ebe-email-card__footer {
  padding: 8px 16px;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
  font-size: 10.5px;
  color: #9ca3af;
}

.ebe-email-card__footer--hidden {
  opacity: 0.3;
  text-decoration: line-through;
}

/* valores de variáveis na prévia */
.ebe-panel--preview ::v-deep .ebe-var-mark {
  background: #fef3c7;
  color: #92400e;
  border-radius: 3px;
  padding: 0 3px;
  font-style: normal;
}

/* ── Texto plano ─────────────────────────────────────── */
.ebe-panel--plaintext {
  background: #fff;
}

.ebe-plaintext-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  background: #fffbeb;
  border-bottom: 1px solid #fde68a;
  font-size: 11px;
  color: #92400e;
}

.ebe-plaintext-area {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  font-family: 'Consolas', 'Menlo', 'Courier New', monospace;
  font-size: 12px;
  color: #374151;
  background: #f9fafb;
  border: none;
  resize: vertical;
  outline: none;
  line-height: 1.65;
  min-height: 148px;
}
</style>
